<div class="router-container">
  <router-outlet></router-outlet>
</div>
<bc-global-notification [message]="globalNotificationMessage()"></bc-global-notification>
